export enum KycStatus {
  notStarted = 'not_started',
  started = 'started',
  inProgress = 'in_progress',
  verified = 'verified',
  declined = 'declined',
  needReKyc = 'need_re_kyc',
}

export const KYC_STATUSES = Object.values(KycStatus);

export const KYC_STATUS_LABELS: Record<KycStatus, string> = {
  [KycStatus.notStarted]: 'Not started',
  [KycStatus.started]: 'Started, but not finished yet',
  [KycStatus.inProgress]: 'In progress',
  [KycStatus.verified]: 'Verified',
  [KycStatus.declined]: 'Declined',
  [KycStatus.needReKyc]: 'Need re-KYC',
};

export interface KycRecord {
  accountId: string;
  provider: string;
  registeredAt: Date;
  country: string;
  status: KycStatus;
  declineReason: string;
}
